import { Navigate } from "react-router-dom";
import { usePortalAuth } from "@/context/PortalAuthContext";
import { Loader2 } from "lucide-react";

export default function PortalProtected({ children }) {
  const { user, loading } = usePortalAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--crm-bg)" }}><Loader2 className="w-6 h-6 animate-spin" style={{ color: "var(--crm-accent)" }} /></div>;
  if (!user) return <Navigate to="/portal/login" replace />;
  return children;
}
